var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExoticDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.31 17.508"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Icon - Exotic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.81 7.081H.5",
    "data-name": "Line 1205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.655 17.009L.5 7.081 4.046.699h9.219l3.545 6.382z",
    "data-name": "Path 5666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.046.698l4.609 6.383",
    "data-name": "Line 1206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.264.698L8.655 7.081",
    "data-name": "Line 1207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.655 7.081v9.928",
    "data-name": "Line 1208"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNy4zMSAxNy41MDgiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkYXRhLW5hbWU9Ikljb24gLSBFeG90aWMiPjxwYXRoIGQ9Ik0xNi44MSA3LjA4MUguNSIgZGF0YS1uYW1lPSJMaW5lIDEyMDUiLz48cGF0aCBkPSJNOC42NTUgMTcuMDA5LjUgNy4wODEgNC4wNDYuNjk5aDkuMjE5bDMuNTQ1IDYuMzgyWiIgZGF0YS1uYW1lPSJQYXRoIDU2NjYiLz48cGF0aCBkPSJtNC4wNDYuNjk4IDQuNjA5IDYuMzgzIiBkYXRhLW5hbWU9IkxpbmUgMTIwNiIvPjxwYXRoIGQ9Ik0xMy4yNjQuNjk4IDguNjU1IDcuMDgxIiBkYXRhLW5hbWU9IkxpbmUgMTIwNyIvPjxwYXRoIGQ9Ik04LjY1NSA3LjA4MXY5LjkyOCIgZGF0YS1uYW1lPSJMaW5lIDEyMDgiLz48L2c+PC9zdmc+";
export { SvgExoticDiamond as ReactComponent };